import { secondsToMilliseconds } from "date-fns";
import { NavigateFunction } from "react-router-dom";

import { FetchResponse } from "@/core/libs/api/utils/fetchData";
import { IOpenModalWithSettings } from "@/hooks/useConfirmModal";
import {
  ITerm,
  TermTypeEnum
} from "@/modules/Terms/interfaces/ITerm.interface";

type HandleTermRouteOptions = {
  response: FetchResponse<ITerm>;
  termId: string;
  expectedTermType: TermTypeEnum;
  navigate: NavigateFunction;
  openModalWithSettings: IOpenModalWithSettings;
};

export const termTypeRoutes = {
  [TermTypeEnum.ASSOCIATION]: "/membership-applications",
  [TermTypeEnum.CHANGE_OF_OWNERSHIP]: "/complementary-documents",
  [TermTypeEnum.ASSOCIATION_AND_PROXY]: "/complementary-documents/proxy"
};

export const handleTermRouteRedirection = ({
  response,
  termId,
  expectedTermType,
  navigate,
  openModalWithSettings
}: HandleTermRouteOptions): void => {
  if (response.error) {
    const fallbackRoute = termTypeRoutes[expectedTermType] || "/";

    openModalWithSettings(
      response.error.message,
      "Você será redirecionado para a página de documentos",
      () => {
        navigate(fallbackRoute);
      },
      { timeOutModeProps: { timeOut: secondsToMilliseconds(2) } }
    );
  }

  const data = response.data;
  const foundTermType = data?.termType;

  if (foundTermType && foundTermType !== expectedTermType) {
    const URL = `${termTypeRoutes[foundTermType]}/${termId}`;

    navigate(URL);
  }
};
